module.exports = __webpack_public_path__ + "img/1477525307.7e6d4d95.jpg";